import {
  FETCH_ORDER_DETAILS_BEGIN,
  FETCH_ORDER_DETAILS_SUCCESS,
  FETCH_ORDER_DETAILS_FAILURE,
  RESET_REDUX,
  RESET_ON_IMPERSONATION
} from "../../actions/actionTypes";

const initialState = {
  orderDetails: [],
  loading: false,
  errors: null,
  request: null,
};

const orderDetailsReducer = (state:any = initialState, action) => {
  switch (action.type) {
    case FETCH_ORDER_DETAILS_BEGIN:
      return {
        ...state,
        loading: true,
        errors: null,
        request: action.payload,
      };

    case FETCH_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        orderDetails: action.payload.orderDetailResponse
      };

    case FETCH_ORDER_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
        orderDetails: []
      };

    case RESET_REDUX:
      return {...initialState}

    case RESET_ON_IMPERSONATION:
      return {...initialState}

    default:
      return state;
  }
}

export default orderDetailsReducer;
